/**
 * The app's one toggle-switch control: a hidden checkbox layered under a track + thumb.
 *
 * Lives on its own because two unrelated surfaces render the same switch (the optimization panel's
 * stage/group toggles and the nav rail's Project Mode toggle) and they must look and behave
 * identically. Callers own the state — this returns a control, it stores nothing.
 */
export function createSwitch(
  checked: boolean,
  onChange: (checked: boolean) => void,
  label?: string,
): HTMLLabelElement {
  const wrapper = document.createElement('label');
  wrapper.className = 'switch';
  // Stage rows are <details>/<summary>; without this, flipping a switch inside the summary would
  // also expand/collapse the row.
  wrapper.addEventListener('click', (e) => e.stopPropagation());
  wrapper.addEventListener('keydown', (e) => e.stopPropagation());
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.checked = checked;
  if (label) input.setAttribute('aria-label', label);
  input.addEventListener('change', () => onChange(input.checked));
  wrapper.appendChild(input);
  const track = document.createElement('span');
  track.className = 'track';
  wrapper.appendChild(track);
  const thumb = document.createElement('span');
  thumb.className = 'thumb';
  wrapper.appendChild(thumb);
  return wrapper;
}
